export enum DocumentTypeEnum {
  TFS = 'TFS',
  TFR = 'TFR',
  TFJ = 'TFJ',
}
